import { IntlShape } from "react-intl";

export default function getGenders(intl: IntlShape) {
  return [
    {
      value: "male",
      label: intl.formatMessage({
        id: "front_male",
        defaultMessage: "Male",
      }),
    },
    {
      value: "female",
      label: intl.formatMessage({
        id: "front_female",
        defaultMessage: "Female",
      }),
    },
  ];
}
